import { render, staticRenderFns } from "./header.vue?vue&type=template&id=72b5ce54&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/pc/header.scss?vue&type=style&index=0&id=72b5ce54&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b5ce54",
  null
  
)

export default component.exports